var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComposing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1656574356019,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2231,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 915.2c-57.6 0-102.4-44.8-102.4-102.4V211.2c0-57.6 44.8-102.4 102.4-102.4h89.6v-64H256v64h390.4v-64h51.2v64h89.6c57.6 0 102.4 44.8 102.4 102.4v204.8H64v403.2c0 25.6 19.2 51.2 51.2 51.2H448c12.8 0 25.6 12.8 25.6 25.6s-12.8 25.6-25.6 25.6l-332.8-6.4z m0-755.2c-25.6 0-51.2 19.2-51.2 51.2v153.6h768V211.2c0-25.6-19.2-51.2-51.2-51.2h-89.6V256H640V160H256V256h-51.2V160H115.2z",
    fill: "#ffffff",
    "p-id": 2232
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 518.4h204.8v51.2H172.8v-51.2zM172.8 710.4h204.8v51.2H172.8v-51.2zM736 761.6V614.4h51.2v96h96v51.2h-147.2z",
    fill: "#ffffff",
    "p-id": 2233
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M761.6 979.2c-64 0-128-25.6-172.8-70.4-44.8-44.8-70.4-108.8-70.4-172.8 0-64 25.6-128 70.4-172.8 44.8-44.8 108.8-70.4 172.8-70.4 64 0 128 25.6 172.8 70.4 44.8 44.8 70.4 108.8 70.4 172.8 0 64-25.6 128-70.4 172.8-44.8 44.8-102.4 70.4-172.8 70.4z m0-441.6c-108.8 0-198.4 89.6-198.4 198.4 0 108.8 89.6 198.4 198.4 198.4s198.4-89.6 198.4-198.4c0-108.8-89.6-198.4-198.4-198.4z",
    fill: "#ffffff",
    "p-id": 2234
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComposing);
export default __webpack_public_path__ + "static/media/composing.915c7329.svg";
export { ForwardRef as ReactComponent };